module.exports = __webpack_public_path__ + "img/20.dfdf7654.gif";